import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

interface StageNoteBrandProps {
  size?: "xs" | "sm" | "md" | "lg";
  theme?: "light" | "dark";
  showBuildInfo?: boolean;
  buildInfoSlot?: React.ReactNode;
}

const sizes = {
  xs: { icon: 22, radius: 5, padding: 3, fontSize: 14, gap: 7 },
  sm: { icon: 26, radius: 7, padding: 4, fontSize: 15, gap: 8 },
  md: { icon: 32, radius: 9, padding: 5, fontSize: 17, gap: 10 },
  lg: { icon: 40, radius: 12, padding: 7, fontSize: 22, gap: 12 },
};

export const StageNoteBrand: React.FC<StageNoteBrandProps> = ({
  size = "md",
  theme = "light",
  buildInfoSlot,
}) => {
  const s = sizes[size];
  const textColor = theme === "dark" ? "white" : "#111827";
  const aiColor = theme === "dark" ? "#818cf8" : "#7c3aed";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: `${s.gap}px` }}>
      <div
        style={{
          width: `${s.icon}px`,
          height: `${s.icon}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #635bff 0%, #8b5cf6 100%)",
          borderRadius: `${s.radius}px`,
          padding: `${s.padding}px`,
          boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
          flexShrink: 0,
        }}
      >
        <img
          src="/logo.svg"
          alt="StageNote Logo"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: "brightness(0) invert(1)",
          }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Text
          style={{
            color: textColor,
            fontSize: `${s.fontSize}px`,
            fontWeight: 700,
            margin: 0,
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          }}
        >
          Stage<span style={{ color: aiColor }}>Note</span><span style={{ color: textColor }}>.</span><span style={{ color: aiColor }}>ai</span>
        </Text>
        {buildInfoSlot && <div style={{ marginTop: "1px" }}>{buildInfoSlot}</div>}
      </div>
    </div>
  );
};
